import { ConnectButton } from '@rainbow-me/rainbowkit';
import { Button, Dropdown, Space } from 'antd';
import { WalletOutlined, DownOutlined } from '@ant-design/icons';
import { useDisconnect } from 'wagmi';
import { useTranslation } from 'react-i18next';

export const WalletButton = () => {
  const { disconnect } = useDisconnect();
  const { t } = useTranslation('header');

  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        const ready = mounted && authenticationStatus !== 'loading';
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus ||
            authenticationStatus === 'authenticated');
        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <Button 
                    type="primary"
                    icon={<WalletOutlined />}
                    onClick={openConnectModal}
                    className="bg-transparent border-gray-700 text-white hover:!bg-transparent hover:!border-gray-700 hover:!text-white rounded-full"
                  >
                    <span className="hidden sm:inline">{t('header_connect_wallet')}</span>
                    <span className="sm:hidden">{t('header_connect')}</span>
                  </Button>
                );
              }
              if (chain.unsupported) {
                return (
                  <Button 
                    danger
                    onClick={openChainModal}
                    className="border-red-500 text-red-500 hover:bg-red-50"
                  >
                    <span className="hidden sm:inline">{t('header_wrong_network')}</span>
                    <span className="sm:hidden">{t('header_network')}</span>
                  </Button>
                );
              }

              const accountMenuItems = [
                {
                  key: 'account',
                  label: (
                    <div className="px-2 py-1">
                      <div className="text-sm font-medium">{account.displayName}</div>
                      {account.displayBalance && (
                        <div className="text-xs text-gray-500">{account.displayBalance}</div>
                      )}
                    </div>
                  ),
                  disabled: true,
                },
                {
                  type: 'divider' as const,
                },
                {
                  key: 'disconnect',
                  label: t('header_disconnect'),
                  onClick: () => {
                    disconnect();
                  },
                },
              ];

              return (
                <Space className="hidden sm:flex">
                  
                  <Dropdown
                    menu={{ items: accountMenuItems }}
                    placement="bottomRight"
                    trigger={['click']}
                  >
                    <Button className="bg-transparent border-gray-700 text-white hover:!bg-transparent hover:!border-gray-700 hover:!text-white rounded-full">
                      <Space className='gap-x-[3px]'>
                        <span className="hidden sm:inline">{account.displayName}</span>
                        <span className="sm:hidden">{account.displayName.slice(0, 6)}...</span>
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </Space>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};